<template>
  <v-container id="productoscruzaados" tag="section">
    <base-v-component heading="Tarifas por catálogos negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          dark
          class="mb-2 ml-5"
          @click="save()"
          :loading="loadingSave"
          >Guardar</v-btn
        >
      </v-toolbar>
      <v-row justify="center">
        <v-card max-width="600" :disabled="loading">
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(c, i) in catalogosTarifaComputed"
                :key="c.value"
              >
                <v-list-item-title>{{ c.text }}</v-list-item-title>
                <v-list-item-action>
                  <v-select
                    :items="tarifasSelect"
                    v-model="catalogosTarifa[i].tarifa"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text> </v-card
      ></v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      loadingSave: false,
      catalogosTarifa: [],
    };
  },
  computed: {
    ...mapState({
      tarifas: (state) => state.productos.tarifas,
      catalogos: (state) => state.catalogos.catalogos,
      productosCatalogos: (state) => state.catalogos.productosCatalogos,
    }),
    tarifasSelect() {
      return this.tarifas.map((t) => {
        return {
          text: t.nombre,
          value: t.id,
        };
      });
    },
    catalogosTarifaComputed() {
      let res = this.catalogosTarifa.map((ct) => {
        return {
          ...this.catalogos.find((c) => c.value == ct.catalogo),
          ...this.tarifas.find((t) => t.id == ct.tarifa),
        };
      });
      return res;
    },
  },
  methods: {
    save() {
      this.loadingSave = true;
      this.$store
        .dispatch("catalogos/setTarifaCatalogo", this.catalogosTarifa)
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Tarifas y catálogos guardado",
          });
        })

        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar tarifas y catálogos: " + error,
          });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getCatalogos() {
      this.loading = true;

      this.$store.dispatch("catalogos/getTodosCatalogos").finally(() => {
        this.loading = false;
        this.catalogosTarifa = this.productosCatalogos.map((c) => {
          return {
            catalogo: c.catalogo,
            tarifa: c.tarifa,
          };
        });
      });
    },
  },
  mounted() {
    this.getCatalogos();
  },
};
</script>

<style>
</style>